import type { RouteRecordRaw } from 'vue-router'

export const objectRoutes: RouteRecordRaw[] = [
  {
    path: '/objects',
    meta: {
      layout: 'dash',
      protected: true,
    },
    children: [
      {
        path: ':type(cabinets)/:object_id',
        name: 'objects.cabinets',
        children: [
          {
            path: ':tab(monitoring)',
            name: 'objects.cabinets.monitoring',
            component: () => import('@/pages/object/CabinetMonitoring'),
          },
          {
            path: ':tab(map)',
            name: 'objects.cabinets.map',
            component: () => import('@/pages/object/CabinetMap'),
          },
          {
            path: ':tab(events)',
            name: 'objects.cabinets.events',
            component: () => import('@/pages/events/EventsIndex'),
          },
          {
            path: ':tab(tasks)',
            name: 'objects.cabinets.tasks',
            component: () => import('@/pages/tasks/TasksIndex'),
          },
          {
            path: ':tab(reports)/:report_type/:content(chart)?',
            name: 'objects.cabinets.reports',
            component: () => import('@/pages/object/CabinetReports'),
          },
          {
            path: ':tab(admin)/:section?',
            name: 'objects.cabinets.admin',
            component: () => import('@/pages/object/CabinetAdmin'),
            meta: {
              tabPermission: 'ADMIN',
            },
          },
        ],
      },
      {
        path: ':type(groups)/:object_id',
        name: 'objects.groups',
        children: [
          {
            path: ':tab(monitoring)',
            name: 'objects.groups.monitoring',
            component: () => import('@/pages/object/GroupMonitoring'),
          },
          {
            path: ':tab(events)',
            name: 'objects.groups.events',
            component: () => import('@/pages/events/EventsIndex'),
          },
          {
            path: ':tab(tasks)',
            name: 'objects.groups.tasks',
            component: () => import('@/pages/tasks/TasksIndex'),
          },
          {
            path: ':tab(admin)/:section?/:list(object-types|import-templates|reports-config|tabs-config)?/:action?/:entity_id?',
            name: 'objects.groups.admin.config',
            component: () => import('@/pages/object/GroupAdmin'),
            meta: {
              tabPermission: 'ADMIN',
            },
          },
          {
            path: ':tab(admin)/:section?/:action?/:entity_id?',
            name: 'objects.groups.admin',
            component: () => import('@/pages/object/GroupAdmin'),
            meta: {
              tabPermission: 'ADMIN',
            },
          },
          {
            path: ':tab(map)',
            name: 'objects.groups.map',
            component: () => import('@/pages/inventory/Map'),
          },
          {
            path: ':tab(reports)',
            name: 'objects.group.reports',
            component: () => import('@/pages/object/GroupReports'),
          },
          {
            path: ':tab(search)',
            component: () => import('@/pages/search/GlobalSearch'),
            name: 'global_search',
          },
        ],
      },
    ],
  },
  {
    path: '/objects/:catchAll(.*)',
    name: 'objects.not_type',
    component: () => import('@/pages/object/NotType'),
  },
]
